import React from "react";
import moment from "moment";
import { Divider, Stack, Typography, Link as MuiLink } from "@mui/material";

import { RoutePaths } from "src/app/model";

export const CopyRight: React.FC = () => {
  return (
    <Stack
      width={1}
      direction="column"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="body2" color="primary">
        Sven Badalyan
      </Typography>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography variant="caption" color="textSecondary">
          © {moment().get("year")}. All rights reserved.
        </Typography>
        <Divider
          orientation="vertical"
          flexItem
          variant="fullWidth"
          sx={{
            borderColor: "text.secondary",
          }}
        />
        <MuiLink
          target="_blank"
          href={RoutePaths.PRIVACY_POLICY}
          color="textSecondary"
          sx={{
            cursor: "pointer",
          }}
        >
          <Typography variant="caption" color="textSecondary">
            Privacy Policy
          </Typography>
        </MuiLink>
      </Stack>
    </Stack>
  );
};
